import attractingPlan from './attractingPlan'
export default attractingPlan
